import type { ExistingVehicle } from 'models/Vehicles/VehicleModel'
import type { ProfilesStoreType } from 'stores/RootStoreModel'

// The title of the vehicle's installed profile. Falls back to the profile id when the profile is not in the
// profiles list (e.g. archived, or the list was not loaded yet).
export const getInstalledProfileTitle = (vehicle: ExistingVehicle, profilesStore: ProfilesStoreType): string | undefined => {
    const installedProfileId = vehicle.vehicle_profile?.installed_profile_id
    if (installedProfileId == null) {
        return undefined
    }
    return profilesStore.getProfile(installedProfileId)?.title ?? installedProfileId
}

// The vehicles with the search text in their number, name or installed profile title (case insensitive)
export const filterVehiclesBySearch = (
    vehicles: ReadonlyArray<ExistingVehicle>,
    searchText: string,
    profilesStore: ProfilesStoreType,
): ExistingVehicle[] => {
    const lowerCaseSearchText = searchText.trim().toLowerCase()
    return vehicles.filter(vehicle =>
        [vehicle.id.toString(), vehicle.name, getInstalledProfileTitle(vehicle, profilesStore)]
            .some(field => field?.toLowerCase().includes(lowerCaseSearchText))
    )
}
